import * as Yup from "yup";
import checkout from "./Form";

const {
  formField: { 
    // datas
    name,
		email,
  },
} = checkout;

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // datas
  Yup.object().shape({
    [name.name]: Yup.string().required(name.errorMsg),
    [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
    // [company.name]: Yup.string().required(company.errorMsg),
  }),
];